import { useContext, createContext, useRef, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ConfirmationToggle } from "../Store/reducers/Toast";
const ConfirmDialog = createContext();
export const ConfirmDialogeProvider = ({ children }) => {
	const [state, setState] = useState({ cancelLabel: 'Cancel', okLabel: 'Okay', description: '' ,isHtml: false, isWidth: false });
	const { confirmDisplay } = useSelector((state) => state.toast);
	const dispatch = useDispatch();
	const fn = useRef();
	const confirm = useCallback((data) => {
		return new Promise((resolve) => {
			setState({ ...state, ...data });
			dispatch(ConfirmationToggle(true));
			fn.current = (choice) => {
				resolve(choice);
				dispatch(ConfirmationToggle(false));
			}
		})
	}, [setState, dispatch]);
	return (
		<>
			<ConfirmDialog.Provider value={confirm}>
				{children}
				{
					confirmDisplay &&
					<div className={`popup-main`} style={{ display: (confirmDisplay) ? 'block' : 'none' }}>
						<div className={`popup-container confirmation ${state.isWidth ? 'diversion-popup-sec' : ''}`} >
							<div className="popup-body">
								<div className="popup-content-wrapper">
									<span className="icon-warning alert"></span>
									{
										state.isHtml ? (
											state.warningType ? (
												<h3 dangerouslySetInnerHTML={{ __html: state.description }}></h3>
											) : (
								<div dangerouslySetInnerHTML={{ __html: state.description }}></div>
											)
										) : (
								<h3>{state.description}</h3>
										)
						}
								</div>
						<div className="btm-btn-popup">
									<button type="button" className="btn btn-blue btn-pp-cancel" onClick={() => fn.current(false)}>{state.cancelLabel}</button>
									<button type="button" className="btn btn-blue btn-pp-okay ms-3" onClick={() => fn.current(true)}>{state.okLabel}</button>
								</div>
							</div>
						</div>
					</div>
				}
			</ConfirmDialog.Provider>
		</>
	)
}
export default function useConfirm() {
	return useContext(ConfirmDialog)
}